// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.88.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.88.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.model-range-text {
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
    justify-content: center;
    -webkit-user-select: none; /* Chrome, Safari, Opera */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none;
    transition: opacity .2s ease-in-out;
    opacity: 0;
    text-decoration: none;
    cursor: pointer;
}

.model-range-animated-fade-in {
    animation: fadeIn .2s forwards ease-in-out;
    opacity: 1;
}

.model-range-main {
    font-family: Nunito Sans, serif;
    font-size: 18px;
    margin: 0 0 10px 0;
    font-weight: 400;
    line-heisght: 1;
    letter-spacing: 0em;
    color: var(--widget-main-color, black)
}

.model-range-model {
    font-family: 'TacticSans-Bld', serif;
    font-size: 84px;
    font-weight: 400;
    margin: 0 0 24px 0;
    line-height: 70px;
    letter-spacing: -0.02em;
    text-align: left;
    color: var(--widget-main-color, black)
}

.model-range-price {
    font-family: Nunito Sans, serif;
    font-size: 18px;
    font-weight: 400;
    margin: 0;
    line-height: 1;
    letter-spacing: 0.02em;
    color: var(--widget-main-color, black)
}

@media screen and (max-width: 800px) {
    .model-range-model {
        font-size: 68px ;
    }
}

@media screen and (max-width: 500px) {
    .model-range-model {
        font-size: 54px ;
    }
}

@keyframes fadeIn {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
`, "",{"version":3,"sources":["webpack://./src/features/text/ui/Text.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB,EAAE,0BAA0B;IACrD,sBAAsB,EAAE,YAAY;IACpC,qBAAqB,EAAE,2BAA2B;IAClD,iBAAiB;IACjB,mCAAmC;IACnC,UAAU;IACV,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,0CAA0C;IAC1C,UAAU;AACd;;AAEA;IACI,+BAA+B;IAC/B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB;AACJ;;AAEA;IACI,oCAAoC;IACpC,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;IAChB;AACJ;;AAEA;IACI,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,cAAc;IACd,sBAAsB;IACtB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ","sourcesContent":[".model-range-text {\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n    align-items: center;\n    justify-content: center;\n    -webkit-user-select: none; /* Chrome, Safari, Opera */\n    -moz-user-select: none; /* Firefox */\n    -ms-user-select: none; /* Internet Explorer/Edge */\n    user-select: none;\n    transition: opacity .2s ease-in-out;\n    opacity: 0;\n    text-decoration: none;\n    cursor: pointer;\n}\n\n.model-range-animated-fade-in {\n    animation: fadeIn .2s forwards ease-in-out;\n    opacity: 1;\n}\n\n.model-range-main {\n    font-family: Nunito Sans, serif;\n    font-size: 18px;\n    margin: 0 0 10px 0;\n    font-weight: 400;\n    line-heisght: 1;\n    letter-spacing: 0em;\n    color: var(--widget-main-color, black)\n}\n\n.model-range-model {\n    font-family: 'TacticSans-Bld', serif;\n    font-size: 84px;\n    font-weight: 400;\n    margin: 0 0 24px 0;\n    line-height: 70px;\n    letter-spacing: -0.02em;\n    text-align: left;\n    color: var(--widget-main-color, black)\n}\n\n.model-range-price {\n    font-family: Nunito Sans, serif;\n    font-size: 18px;\n    font-weight: 400;\n    margin: 0;\n    line-height: 1;\n    letter-spacing: 0.02em;\n    color: var(--widget-main-color, black)\n}\n\n@media screen and (max-width: 800px) {\n    .model-range-model {\n        font-size: 68px ;\n    }\n}\n\n@media screen and (max-width: 500px) {\n    .model-range-model {\n        font-size: 54px ;\n    }\n}\n\n@keyframes fadeIn {\n    0% {\n        opacity: 0;\n    }\n    100% {\n        opacity: 1;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
